/*
 * Sharon Goldberg Fitness – Home Page
 * Design: Botanical Wellness (Organic Naturalism)
 * Colors: Forest Green (#2D5A3D), Warm Beige (#F5F0E8), Coral (#E8A87C)
 * Typography: Frank Ruhl Libre (headings), Heebo (body)
 * Layout: Asymmetric scroll, RTL, organic shapes
 */

import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import SpecializationsSection from "@/components/SpecializationsSection";
import ServicesSection from "@/components/ServicesSection";
import GallerySection from "@/components/GallerySection";
import ClientLove from "@/components/ClientLove";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import AccessibilityWidget from "@/components/AccessibilityWidget";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col" dir="rtl">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <SpecializationsSection />
        <ServicesSection />
        <GallerySection />
        <ClientLove />
        <ContactSection />
      </main>
      <Footer />
      {/* Persistent floating elements */}
      <FloatingWhatsApp />
      <AccessibilityWidget />
    </div>
  );
}
